// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pZ70","colBig":"styles_colBig__3XzDZ","colSmall":"styles_colSmall__Yb9fm"};